import classNames from 'classnames';
import React from 'react';
import { Col, Row } from 'reactstrap';
import { Nps } from '../../../../entities/survey_engine/Nps';
import { SpanTooltip } from '../../../SpanTooltip';
import { Trend } from '../../Trend';
import { AnalyticsPanel } from '../../../AnalyticsPanel';
import { NpsChip } from './NpsChip';
import { OverallNpsCharts } from './OverallNpsCharts';

interface PropTypes {
  nps: Nps;
  npsTrend?: number;
  title: string;
  detractorsText: string;
  neutralsText: string;
  promotersText: string;
  tooltipText: JSX.Element;
  standardNpsCalculation?: boolean;
}

export function OverallNps(props: PropTypes) {
  return (
    <AnalyticsPanel
      title={
        <div>
          <div className={classNames('mb-0', 'fw-bold')}>
            <span className='fs-2'>{props.title}</span>
            <SpanTooltip
              className='ms-2 text-info'
              placement='right'
              text={<i className='bi bi-info-circle'></i>}
              tooltipText={props.tooltipText}
              tooltipStyle={{ maxWidth: '250px' }}
            />
          </div>
        </div>
      }
      subtitle={null}
      marginTop={props.standardNpsCalculation ? 'mt-0' : 'mt-3'}
    >
      <div className='flex-grow-1 d-flex align-items-center'>
        <Row>
          <Col xs={6} className='px-4 d-flex flex-column align-items-center'>
            <OverallNpsCharts
              nps={props.nps}
              standardNpsCalculation={props.standardNpsCalculation}
            />
            <div className='mt-3 fs-6'>
              <Trend trend={props.npsTrend} />
            </div>
          </Col>
          <Col
            xs={6}
            className='d-flex flex-column justify-content-center ps-5 pe-0'
          >
            <dl className='row mt-5'>
              <NpsChip
                npsRatio={props.nps.detractors}
                npsText={props.detractorsText}
              />
              <NpsChip
                npsRatio={props.nps.neutrals}
                npsText={props.neutralsText}
              />
              <NpsChip
                npsRatio={props.nps.promoters}
                npsText={props.promotersText}
              />
            </dl>
          </Col>
        </Row>
      </div>
    </AnalyticsPanel>
  );
}
